module.exports = __webpack_public_path__ + "static/media/SativaCG.6c793462.png";